<template>
  <div>
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="所属分类">
        <Cascader
          :data="catagoris"
          v-model="searchCondition.classify_ids"
          trigger="hover"
          style="width:200px;"
          change-on-select
        ></Cascader>
      </FormItem>
      <FormItem label="活动状态">
        <Select v-model="searchCondition.checkin_status" style="width:200px;" clearable>
          <Option
            v-for="(item, index) in checkinStatus"
            :key="index"
            :value="index"
          >{{item}}</Option>
        </Select>
      </FormItem>
      <FormItem label="活动名称">
        <Input
          v-model="searchCondition.name"
          placeholder="请输入活动名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </FormItem>
    </Form>
    <Button type="primary"  :to="{name: 'QuestionCheckinAdd'}" style="margin-right:50px;">
      新增打卡
      </Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/exam/checkin"
        :search="searchCondition"
        @onSelectionChange="onSelectionChange"
        :rowsFormatter="rowsFormatter"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" v-if="row.is_release != 1" size="small" @click="release(row)">发布</Button>
            <span v-else>已发布</span>
            <span>-</span>
            <Button type="text" size="small" :to="{name: 'QuestionCheckincCalendar', query: {id: row.id,date:row.start_time }}">添加题目</Button>
            <span>-</span>
            <Button type="text" size="small" v-if="row.people>0" :to="{name: 'QuestionJoiner', query: {id: row.id }}">学员列表 - </Button>
            <Button type="text" size="small" :to="{name: 'QuestionCheckinAdd', query: {id: row.id }}">编辑</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onForbidden(row.id)">删除</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button class="btn-margin-right" size="small" @click="onForbidden()">删除</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "QuestionCheckinManage",
  data() {
    return {
      catagoris: [],
      checkinStatus: {
          '-1': '未开始',
          '1': '进行中',
          '2': '已结束',
      },
      searchCondition: {
        checkin_status: "",
        name: "",
        classify_id: "",
        classify_ids: [],
        init: function() {
          this.checkin_status = "";
          this.name = "";
          this.classify_id= "";
          this.classify_ids= [];
        }
      },
      onlyShowMe: false,
      tableColumns: [
        { title: "练习名称", key: "name", align: "center", minWidth: 180 },
        {
          title: "所属分类",
          key: "classify_name",
          align: "center",
          minWidth: 100
        },
        { title: "活动状态", key: "activity_state", align: "center", minWidth: 100 },
        { title: "有效期", key: "range_time", align: "center", minWidth: 200 },
        { title: "已进行/总天数", key: "days", align: "center", minWidth: 100 },
        { title: "参与人数", key: "people", align: "center", minWidth: 100 },
        { title: "状态", key: "is_release_name", align: "center", minWidth: 100 },
        {
          title: "更新时间",
          key: "updated_at",
          align: "center",
          minWidth: 160
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 250,
          fixed: "right"
        }
      ],
      selectItems: []
    };
  },
  async created() {
    let catagoris = await this.$http.get("/api/course/classify");
    this.catagoris = catagoris;
  },
  methods: {
    rowsFormatter(rows) {
      let nowTime = Date.parse(new Date());
      rows.forEach(item => {
        item.classify_name = item.classify.title;
        item.updated_at = this.$pub.timestampToTime(item.updated_at);
        item.is_release_name =
          item.is_release == 1
            ? "已发布"
            : "未发布";
        item.end_time += 23*3600 + 59*60 + 59;
        let currentTime = parseInt(new Date().getTime() / 1000);
        let totalDay = Math.floor((item.end_time - item.start_time) / (24 * 3600))+1;
        if (item.start_time > currentTime) {
          item.activity_state = "未开始";
          item.days = 0 + '/' + totalDay;
        } else if (item.start_time <= currentTime && item.end_time >= currentTime) {
          item.activity_state = "进行中";
          let activeDay = Math.floor((currentTime - item.start_time) / (24 * 3600))+1;
          item.days =  activeDay + '/' + totalDay;
        } else {
          item.activity_state = "已结束";
          item.days =  totalDay + '/' + totalDay;
        }
        item.range_time = new Date(item.start_time*1000).format('yyyy/MM/dd') + '-' + new Date(item.end_time*1000).format('yyyy/MM/dd')
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.init();
      }
      this.searchCondition.classify_id = this.searchCondition.classify_ids[1] ||  this.searchCondition.classify_ids[0];
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(items) {
      this.selectItems = items;
    },
    release(row) {
      if( row.activity_state == "已结束" ) {
        this.$Modal.confirm({
          title: "提示",
          content: "<p>活动已结束，不可发布</p>"
        });
        return
      }
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要发布该打卡活动吗？</p>",
        onOk: () => {
          this.$http.put(`/api/exam/checkin/release/${row.id}`,{id: row.id,release: 1}).then(() => {
            this.search(1);
          });
        }
      });
    },
    /**
     * @param {String} id    试卷id
     */
    onForbidden(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>删除活动后，用户将不能答题或查看打卡记录，确定删除吗？</p>",
        onOk: () => {
          this.nextAction(id);
        }
      });
    },
    nextAction(id) {
      let ids = "";
      if (id) {
        ids = id;
      } else {
        this.selectItems.forEach(item => {
          ids += item.id + ",";
        });
        ids = ids.substr(0, ids.length - 1);
      }
      this.$http.delete(`/api/exam/checkin/${ids}`).then(() => {
        this.$Message.deleteSuccess();
        this.search(1);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  .modal-item {
    border: 1px solid #eee;
    width: 180px;
    padding: 20px;
    cursor: pointer;
    .modal-item-title {
      text-align: center;
      margin-bottom: 10px;
    }
  }
}
</style>
